import React from "react";

const MomentumIcon = ({ className = "", size = 40 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="8"
        y="46"
        width="8"
        height="10"
        rx="1"
        fill="#00FF8F"
        fillOpacity="0.2"
      />
      <rect
        x="20"
        y="36"
        width="8"
        height="20"
        rx="1"
        fill="#00FF8F"
        fillOpacity="0.4"
      />
      <rect
        x="32"
        y="28"
        width="8"
        height="28"
        rx="1"
        fill="#00FF8F"
        fillOpacity="0.6"
      />
      <rect
        x="44"
        y="18"
        width="8"
        height="38"
        rx="1"
        fill="#00FF8F"
        fillOpacity="0.8"
      />

      {/* Trend line */}
      <path
        d="M10 36C10 36 18 34 24 28C30 22 38 14 50 12"
        stroke="#00FF8F"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Arrow */}
      <path
        d="M42 8L50 12L54 4"
        stroke="#00FF8F"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Pulse effect circles */}
      <circle cx="50" cy="12" r="4" fill="#00FF8F" fillOpacity="0.8" />
      <circle
        cx="50"
        cy="12"
        r="8"
        stroke="#00FF8F"
        strokeOpacity="0.5"
        strokeWidth="1"
      />
      <circle
        cx="50"
        cy="12"
        r="12"
        stroke="#00FF8F"
        strokeOpacity="0.2"
        strokeWidth="1"
      />
    </svg>
  );
};

export default MomentumIcon;
